import React, { useState, useEffect } from "react";
import { useAdmin } from "../contexts/AdminContext";
import "../styles/Login.css";
import logo from "../assets/spashscreenLogo.png";
import API_URL from "../config";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [branch, setBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const { login } = useAdmin();

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await fetch(`${API_URL}/admin`);
        const data = await response.json();

        if (response.ok) {
          const uniqueBranches = [
            ...new Set(data.map((admin) => admin.branch.toUpperCase())),
          ];
          setBranches(uniqueBranches);
        } else {
          console.error("Failed to fetch branches:", data.message);
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    fetchBranches();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_URL}/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password, branch }),
      });
      const data = await response.json();

      if (response.ok) {
        login(data.user, data.token, data.userType);
        alert("Login successful!");
      } else {
        alert(data.message || "Username or password invalid!");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("An error occurred during login.");
    }
  };

  return (
    <div className="auth-container">
      <img src={logo} alt="Company Logo" className="company-logo" />
      <div className="auth-inner-container">
        <h2>Login</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="branch">Select Branch:</label>
            <select
              id="branch"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              required
            >
              <option value="" disabled>
                Select your branch
              </option>
              {branches.map((branchName, index) => (
                <option key={index} value={branchName}>
                  {branchName} Branch
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
